<template>
  <span v-if="instruction">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          color="primary"
          label
          dark
          class="instruction-chip"
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>mdi-book-open-variant</v-icon>
        </v-chip>
      </template>
      <span>Instruction</span>
    </v-tooltip>
    <v-dialog v-model="dialog" max-width="900" scrollable>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span>Instruction</span>
          <v-btn icon small @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4" style="max-height: 70vh">
          <div class="instruction-content" v-html="instruction"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'InstructionChip',
  props: {
    instruction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>
.instruction-chip {
  cursor: pointer;
}
</style>
